/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ChangelogInputs */

const id_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios`)
};

const es_mx2_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios`)
};

const fil_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng mga Pagbabago`)
};

const fr_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal des modifications`)
};

const it_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações`)
};

const pt_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

const zh_hant1_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌`)
};

const ko_nav_changelog = /** @type {(inputs: Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Nav_ChangelogInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_changelog = /** @type {((inputs?: Nav_ChangelogInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ChangelogInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_changelog(inputs)
	if (locale === "ms") return ms_nav_changelog(inputs)
	if (locale === "da") return da_nav_changelog(inputs)
	if (locale === "de") return de_nav_changelog(inputs)
	if (locale === "en-US") return en_us2_nav_changelog(inputs)
	if (locale === "es-ES") return es_es2_nav_changelog(inputs)
	if (locale === "es-MX") return es_mx2_nav_changelog(inputs)
	if (locale === "fil") return fil_nav_changelog(inputs)
	if (locale === "fr") return fr_nav_changelog(inputs)
	if (locale === "it") return it_nav_changelog(inputs)
	if (locale === "hu") return hu_nav_changelog(inputs)
	if (locale === "nl") return nl_nav_changelog(inputs)
	if (locale === "no") return no_nav_changelog(inputs)
	if (locale === "pl") return pl_nav_changelog(inputs)
	if (locale === "pt-BR") return pt_br2_nav_changelog(inputs)
	if (locale === "pt") return pt_nav_changelog(inputs)
	if (locale === "ro") return ro_nav_changelog(inputs)
	if (locale === "fi") return fi_nav_changelog(inputs)
	if (locale === "sv") return sv_nav_changelog(inputs)
	if (locale === "vi") return vi_nav_changelog(inputs)
	if (locale === "tr") return tr_nav_changelog(inputs)
	if (locale === "cs") return cs_nav_changelog(inputs)
	if (locale === "bg") return bg_nav_changelog(inputs)
	if (locale === "ru") return ru_nav_changelog(inputs)
	if (locale === "uk") return uk_nav_changelog(inputs)
	if (locale === "ar") return ar_nav_changelog(inputs)
	if (locale === "hi") return hi_nav_changelog(inputs)
	if (locale === "th") return th_nav_changelog(inputs)
	if (locale === "ja") return ja_nav_changelog(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_changelog(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_changelog(inputs)
	return ko_nav_changelog(inputs)
});
export { nav_changelog as "nav.changelog" }